import { Resource as e } from "@coveo/platform-client";
//#region src/resources/ReportInternalResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/ua/v15/reports";
	}
	listReportsByProjectId(e, n = {}) {
		return this.api.get(this.buildPath(`${t.baseUrl}/projects/list`, {
			...n,
			org: this.api.organizationId,
			projectId: e
		}));
	}
};
//#endregion
export { t as ReportInternalResource };

//# sourceMappingURL=ReportInternalResource.js.map